/**
 * Central contact info for Al-Ahliyya College (מכללת באר שבע הקהילתית בע״מ).
 * Change here → propagates everywhere on the site.
 */

// --- WhatsApp (international) ---
export const COLLEGE_WHATSAPP_E164 = "972505609003";       // wa.me deep-link format
export const COLLEGE_WHATSAPP_DISPLAY = "050-560-9003";     // human-readable format
export const COLLEGE_WHATSAPP_TEL = "+972505609003";        // callable tel: link

// --- Landline (main phone) ---
export const COLLEGE_TEL = "+97286232014";                  // machine-readable
export const COLLEGE_TEL_DISPLAY = "08-6232014";            // human-readable

// --- Fax ---
export const COLLEGE_FAX_DISPLAY = "08-6232003";

// --- Email ---
export const COLLEGE_EMAIL = "support@ah-online.com";

// --- Legal entity ---
export const LEGAL_NAME_HE = "מכללת באר שבע הקהילתית בע\"מ";
export const LEGAL_NAME_EN = "Beer Sheva Community College Ltd.";
export const COMPANY_CP = "514196864";                       // ח.פ.

/**
 * Build a wa.me deep link with an optional prefilled Arabic/Hebrew message.
 */
export function buildWhatsAppLink(preset = "") {
    const base = `https://wa.me/${COLLEGE_WHATSAPP_E164}`;
    if (!preset) return base;
    return `${base}?text=${encodeURIComponent(preset)}`;
}
